module.exports = __webpack_public_path__ + "img/preventitive.2a39f271.jpeg";